import { Flex } from "src/components/Flex.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import * as styles from "./AssignedRecordsTable.style.ts";

export const AssignedRecordsTable = ({
  rows,
}: {
  rows: {
    id: string;
    title: string;
  }[];
}) => {
  if (rows.length === 0) {
    return null;
  }
  return (
    <Flex flexDirection={"column"}>
      {rows.map((row) => (
        <TextV2 variant={"body1"} css={styles.previewRow} key={row.id}>
          {row.title}
        </TextV2>
      ))}
    </Flex>
  );
};
